"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverHeader: function() {
        return _TeachingPopoverHeader.TeachingPopoverHeader;
    },
    renderTeachingPopoverHeader_unstable: function() {
        return _renderTeachingPopoverHeader.renderTeachingPopoverHeader_unstable;
    },
    teachingPopoverHeaderClassNames: function() {
        return _useTeachingPopoverHeaderStylesstyles.teachingPopoverHeaderClassNames;
    },
    useTeachingPopoverHeaderStyles_unstable: function() {
        return _useTeachingPopoverHeaderStylesstyles.useTeachingPopoverHeaderStyles_unstable;
    },
    useTeachingPopoverHeader_unstable: function() {
        return _useTeachingPopoverHeader.useTeachingPopoverHeader_unstable;
    }
});
const _TeachingPopoverHeader = require("./TeachingPopoverHeader");
const _renderTeachingPopoverHeader = require("./renderTeachingPopoverHeader");
const _useTeachingPopoverHeader = require("./useTeachingPopoverHeader");
const _useTeachingPopoverHeaderStylesstyles = require("./useTeachingPopoverHeaderStyles.styles");
